import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../Common.scss";
import "./Header.scss";
import { Scrollbars } from "react-custom-scrollbars";
import Api from "../../Common/api.jsx";
import { Navigate } from "react-router-dom";
import SearchResult from "../../Pages/SearchResult";
import { ethers } from "ethers";
import ErrorHandler from "../../Helpers/ErrorHandler.jsx";
import { notifications } from "../../Helpers/Notifications";
import MetaMaskService from "../../Common/metamaskService.jsx";
import CommonHelper from "../../Helpers/CommonHelper.jsx";
import Web3Modal from "web3modal";
import NFTMarket from "../../../artifacts/contracts/NFTMarket.sol/NFTMarket.json";

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.isOpen = false;
    // (this.accountId = null),
    this.timeout = 0;
    this.state = {
      mobileMenu: "",
      searchBox: "",
      connectWallet: "",
      users: [],
      assets: [],
      collections: [],
      cartList: [],
      value: "",
      isSwitchingNetwork: false,
      redirect: null,
      accountId: null,
      profilePicture: null,
      totalPrice: 0,
      totalUsd: 0,
      continue: false,
      account: "",
      chainConfig: null,
      showSwitchNetworkPopup: false,
      isBuying: false,
      addFundWithCard: false
    };
  }

  async componentDidMount() {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    console.log(params.get("search"));
    if (
      params.get("search") != null &&
      params.get("search") != "" &&
      params.get("search") != "null"
    ) {
      this.setState({ value: params.get("search") });
    }

    let account = localStorage.getItem("accountId");
    let profileimg = localStorage.getItem("profilePicture");

    if (account) {
      this.setState({ accountId: account });
      if (profileimg) {
        this.setState({ profilePicture: profileimg });
      }
      account = await new MetaMaskService().getAccount();
      localStorage.setItem("accountId", account);
      this.setState({account: account});
      this.getCartList(account);
    }

    if (window.ethereum) {
      window.ethereum.on("accountsChanged", async (accounts) => {
        await this.updateUserDetails(accounts[0]);
        window.location.reload();
      });
    }
  }

  async updateUserDetails(account) {
    localStorage.removeItem("accountId");
    localStorage.removeItem("profilePicture");
    try {
      var user = {
        email: "",
        user_name: "",
        profile_pic: "",
        twitter_profile: "",
        banner_pic: "",
        phone_num: "",
        account: account.toLowerCase(),
      };

      await new Api().post("user_details/", user);

      await new Api()
        .get("get_user/?account=" + account)
        .then((response) => {
          localStorage.setItem("accountId", account);
          if (response.data.profile_picture)
            localStorage.setItem(
              "profilePicture",
              response.data.profile_picture
            );
        })
        .catch((err) => console.log(err));
    } catch (err) {
      notifications.error("Something went wrong.");
    }
  }

  onChange(event) {
    this.setState(event.target.value);
  }

  closePopup() {
    this.setState({ continue: false })
  }
  async openCheckoutPopup() {
    await this.setState({ continue: true })
    this.explorrerCollectionClose()
  }

  async getContract() {
    const web3Modal = new Web3Modal();
    const connection = await web3Modal.connect();
    const provider = new ethers.providers.Web3Provider(connection);
    const signer = provider.getSigner();
    const contract = new ethers.Contract(
      this.state.chainConfig.NFT_MARKETPLACE_ADDRESS,
      NFTMarket.abi,
      signer
    );

    return contract;
  }

  async buyMultipleNft() {
    // event.preventDefault();
    try {
      console.log(this.state.cartList)
      // /* user will be prompted to pay the asking process to complete the transaction */
      const chainConfig = await new CommonHelper().getChainConfig(
        this.state.cartList[0].chain_id
      );
      this.setState({ chainConfig: chainConfig });

      var complete = 0;
      for (let i = 0; i < this.state.cartList.length; i++) {

        /*if (window.ethereum.networkVersion !== this.state.chainConfig.CHAIN_ID) {
          this.setState({ showSwitchNetworkPopup: true });
          return;
        }*/

        this.setState({ isBuying: true });
        var contract = await this.getContract();
        const price = ethers.utils.parseUnits(
          this.state.cartList[i].price.toString(),
          "ether"
        );

        await contract
          .createMarketSale(this.state.cartList[i].token_id, {
            value: price,
          })
          .then(
            async (transactionDetails) => {
              var tx = await transactionDetails.wait();
              // console.log(" transaction", receipt);
               var asset_activity={
                from_account: this.state.cartList[i].owner_account,
                to_account: this.state.account,
                price: this.state.cartList[i].price,
                asset_id: this.state.cartList[i].asset_id,
                currency: this.state.chainConfig.CURRENCY_SYMBOL,
                activity_type_id: 3,
                transaction_hash: tx.transactionHash,
              };


              await new Api().post("create_activity/", asset_activity);
              complete++;
             // this.setState({ continue: true });
             this.removeCart(this.state.cartList[i].cart_id,2);
              console.log(complete, this.state.cartList.length);
              if (complete == this.state.cartList.length) {
                notifications.success("Order executed successfully");
                this.removeCart(this.state.cartList[i].cart_id,0);
                this.setState({continue:false})
                this.props.hideCartButton()
              }
            },
            (err) => {
              console.log("error", err);
              this.setState({ isBuying: false });
              new ErrorHandler().processEtherMessage(err);
            }
          );
      }

    } catch (err) {
      console.log(err)
      notifications.error("Something went wrong.");
      this.setState({ isBuying: false });
    }
  }
  onSearch(e) {
    this.setState(e);
    // our api to fetch the search result
    console.log("search ", e);
  }
  // updateCartList(){
  //   this.getCartList();
  // }
  getSearchBar(event) {
    const api = new Api();
    this.setState({ value: event.target.value });
    this.setState({ collections: [] });
    this.setState({ users: [] });
    this.setState({ assets: [] });
    var parameter = "";
    if (this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      api
        .get("search/?text=" + event.target.value, parameter)
        .then((response) => {
          this.isOpen = true;
          this.setState({ assets: response.data["assets"] });
          this.setState({ collections: response.data["collections"] });
          this.setState({ users: response.data["users"] });
        })
        .catch((err) => console.log(err));
    }, 1000);
  }

  mobileMenuFun() {
    document.body.classList.toggle("mobileMenuActive", "mobileMenu");
  }

  mobileSearchBack(event) {
    document.body.classList.remove("searchBoxActive");
    this.setState({ value: "" });
    this.setState({ collections: [] });
    this.setState({ users: [] });
    this.setState({ assets: [] });
  }

  searchBoxFun() {
    document.body.classList.toggle("searchBoxActive", "searchBox");
  }

  searchResultPage(event) {
    const search2 = window.location.search;
    const params = new URLSearchParams(search2);

    let s = new SearchResult();
    console.log(event.keyCode, this.state.value);
    if (event.keyCode == 13 && this.state.value) {
      let tab = params.get("tab") ? params.get("tab") : "Asset";
      console.log(tab);
      const search = window.location;
      if (search.pathname == "/SearchResult/") {
        s.updateT(tab, this.state.value);
        this.props.onSearchCallBack(tab, this.state.value); // trigger the callback function to fetch the updated data as per search keyword
      }
      this.setState({
        redirect: "../SearchResult/?tab=" + tab + "&search=" + this.state.value,
      });
    }
  }

  searchResultPageIcon(event) {
    const search2 = window.location.search;
    const params = new URLSearchParams(search2);
    let s = new SearchResult();
    let tab = params.get("tab") ? params.get("tab") : "Asset";
    const search = window.location;
    if (search.pathname == "/SearchResult/") {
      s.getSearchResult(tab, this.state.value);
    }
    if (this.state.value) {
      this.setState({
        redirect: "../SearchResult/?tab=" + tab + "&search=" + this.state.value,
      });
    }
  }

  hidShowPopup(e) {
    this.isOpen = false;
    console.log(this.isOpen);
  }

  async switchNetwork() {
    this.setState({ isSwitchingNetwork: true });
    let web3 = window.ethereum;

    const result = await web3
      .request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: this.props.chainId }],
      })
      .catch((err) => {
        new ErrorHandler().processEtherMessage(err);
        return;
      });

    if (result === null) {
      notifications.success(
        `Network switched to ${this.props.network} successfully`
      );
    }

    setTimeout(() => {
      this.props.onPopupClose(true);
      this.setState({ isSwitchingNetwork: false });
    }, 500);
  }
  cartPopup() {
    let account = localStorage.getItem("accountId");
    this.getCartList(account);
    document.body.classList.toggle("cartActive");
    document
      .querySelector(".cart-popup")
      .classList.toggle("cartOpen");
  }

  addFundWithCard() {
    this.setState({ addFundWithCard: true });
  }
  closeaddFundWithCard(){
    this.setState({ addFundWithCard: false });
  }
  explorrerCollectionClose() {
    document.body.classList.toggle("cartActive");
    document
      .querySelector(".cart-popup")
      .classList.remove("cartOpen");
  }

  async logoutUser() {
    localStorage.removeItem("accountId");
    localStorage.removeItem("profilePicture");
    this.setState({ accountId: null });
    this.setState({ redirect: "/" });
  }

  getCartList(account) {
    console.log(account)
    if (account) {
      new Api().get("get_user_cart/?account=" + account).then((response) => {
        this.setState({ cartList: response.data });
        let usd = 0;
        let price = 0;
        this.state.cartList.map((id) => {
          usd = usd + parseFloat(id.usd_amount);
          price = price + parseFloat(id.price);
        });
        this.setState({ totalPrice: price, totalUsd: usd });
      }).catch((err) => console.log(err));
    }
  }

  removeCart(cartId,flag) {
    let cartIds = []
    if (cartId == 'All') {
      this.state.cartList.map((id) => {
        cartIds.push(id.cart_id + "");
      });
      this.explorrerCollectionClose();
    } else {
      cartIds.push(cartId + "");
    }

    var body = {
      cartId: cartIds,
      account: this.state.accountId,
    };
    new Api().post("remove_cart_item/", body).then((response) => {
      this.getCartList(this.state.accountId);
      if(flag==0){
        notifications.success("Transaction successfully");
      }else if(flag==1){
        notifications.success("Removed From Cart successfully");
      }
    }).catch((err) => {
      notifications.error("Something went wrong..");
      console.log(err)
    });
  }

  render = () => {
    if (this.state.redirect) {
      var url = this.state.redirect;
      this.setState({ redirect: null });
      return (
        <Navigate
          // to={"../SearchResult/?tab=Asset&search=" + this.state.value}
          to={url}
          replace={true}
        />
      );
    }
    return (
      <>

        <div className="funds-popup" style={{ display: this.state.continue === true ? 'flex' : 'none' }}>
          <div className="funds-popup__aside">
            <button className="btn-close" onClick={() => { this.closePopup(true); }} >
              <img src="../images/svg/btn-popup-close.svg" alt="close" />
            </button>
            <h2>ADD FUNDS</h2>
            <h5>You need {this.state.totalPrice} ETH + <strong>gas fees</strong> </h5>
            <p>Transfer funds to your wallet or add funds with card to complete this purchase. It can up to a minute for your balance to update.</p>
            <ul className="fund-list">
              {this.state.cartList.map((item, index) => (
                <li>
                  <a href="javascript:void(0)">
                    <div className="left">
                      <i><img src="../images/ethereum.png" alt="" /></i>
                      <h4>{item.domain_name}</h4>
                      <p>{item.currency_name}</p>
                    </div>
                    <div className="right">
                      <h4>{item.price} ETH</h4>
                      <p>Balance</p>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
            {this.state.isBuying == true ?  <span> <br/> Wait, transaction in proccess..</span> : ''}
            {this.state.isBuying == false ? (
              <button className="button"
                onClick={() => {
                  this.buyMultipleNft();
                }} >
                Continue
              </button>
            ) : (
              <button className="button"> <img style={{height:41+'px'}}
              className="header-loader"
              src="../Loader/redshilliz-loader.gif "
              alt="Coin"
            /> Continue... </button>
            )}
            <button className="button button__text" onClick={() => {
              this.addFundWithCard();
            }}>Add funds with card</button>
          </div>
        </div>

        {
          this.state.addFundWithCard == true ? (
            <div className="funds-with-card-popup">
              <div className="funds-with-card-popup__aside">
                <button className="btn-close" onClick={() => { this.closeaddFundWithCard(true); }} >
                  <img src="../images/svg/btn-popup-close.svg" alt="close" />
                </button>
                <h3><a href="#"><img src="../images/svg/left-arrow.svg" alt="close" /></a> Add Funds With Card</h3>
                <div className="frame-box">
                  <h3 className="black">Third party iframe goes here</h3>
                </div>
                <p>Powered by XYZ company</p>
              </div>
            </div>
          ) : (
            <></>
          )}
        {this.props.showSwitchNetworkPopup == true ? (
          <div className="connect-wallet-popup">
            <div className="connect-wallet-popup__aside">
              <button
                className="btn-close"
                onClick={() => {
                  this.props.onPopupClose(true);
                }}
              >
                <img src="../images/svg/btn-popup-close.svg" alt="close" />
              </button>
              <div className="section-title">
                <h4>Please switch to {this.props.network} network</h4>
              </div>
              <section className="popup-desc">
                <span>
                  In order to trade items, please switch to {this.props.network}{" "}
                  network within your MetaMask wallet.
                </span>
              </section>
              <div className="form-group-margin form-group__btn">
                <button
                  className="action_btn button margin-right cancel"
                  onClick={() => {
                    this.props.onPopupClose(true);
                  }}
                >
                  Cancel
                </button>
                {this.state.isSwitchingNetwork ? (
                  <button className="action_btn button btn-waiting ">
                    {/* <img
                      className="header-loader"
                      src="../Loader/redshilliz-loader.gif "
                      alt="Coin"
                    /> */}
                    Switching...
                  </button>
                ) : (
                  <button
                    className="action_btn button"
                    onClick={() => {
                      this.switchNetwork();
                    }}
                  >
                    Switch Network
                  </button>
                )}
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        <header className="header">
          <div className="container" onClick={(e) => this.hidShowPopup(e)}>
            <div className="navbar">
              <div className="navbar__left">
                <Link to="/" className="logo">
                  <img src="../images/logo.svg" alt="redShilliz" />
                </Link>
                <div className="search-wrap">
                  <input
                    type="text"
                    placeholder="Search NFTs, collections, and accounts"
                    value={this.state.value}
                    onChange={(e) => this.getSearchBar(e)}
                    onKeyUp={(event) => this.searchResultPage(event)}
                  />
                  <button
                    type="button"
                    onClick={(event) => this.searchResultPageIcon(event)}
                  >
                    <img src="../images/search.svg" alt="Search" />
                  </button>
                  {
                    <div
                      className="search-autocomplete"
                      style={{
                        display:
                          (this.state.users.length > 0 ||
                            this.state.assets.length > 0 ||
                            this.state.collections.length > 0) &&
                            this.isOpen
                            ? "block"
                            : "none",
                      }}
                    >
                      <Scrollbars className="custmScrollbar">
                        <ul className="search-autocomplete_list">
                          <label>Items</label>
                          {this.state.assets.map((item) => (
                            <li key="0">
                              <img
                                className="item-img"
                                //src="../images/card1.png"
                                src={
                                  item.asset_image
                                    ? item.asset_image
                                    : "../images/card1.png"
                                }
                                alt="seacrh"
                              />
                              <div className="txt">
                                <Link
                                  to={"../NftDetails/?assetId=" + item.asset_id}
                                >
                                  <h5>
                                    {item.asset_name}{" "}
                                    {item.is_verified == true ? (
                                      <img
                                        className="mark"
                                        src="../images/verify.png"
                                        alt="seacrh"
                                      />
                                    ) : (
                                      false
                                    )}
                                  </h5>{" "}
                                  {/* <span>1 of 100</span> */}
                                </Link>
                              </div>
                            </li>
                          ))}
                        </ul>

                        <ul className="search-autocomplete_list">
                          <label>Collections</label>
                          {this.state.collections.map((item) => (
                            <li key="1">
                              <img
                                className="item-img"
                                //src="../images/card2.png"
                                src={
                                  item.collection_image
                                    ? item.collection_image
                                    : "../images/card2.png"
                                }
                                alt="seacrh"
                              />
                              <div className="txt">
                                <Link
                                  to={
                                    "../CollectionDetails/?collectionId=" +
                                    item.collection_id
                                  }
                                >
                                  <h5>
                                    {item.collection_name}{" "}
                                    {item.is_verified == true ? (
                                      <img
                                        className="mark"
                                        src="../images/verify.png"
                                        alt="seacrh"
                                      />
                                    ) : (
                                      false
                                    )}
                                  </h5>{" "}
                                </Link>
                              </div>
                            </li>
                          ))}
                        </ul>

                        <ul className="search-autocomplete_list">
                          <label>Users</label>
                          {this.state.users.map((item) => (
                            <li key="0">
                              <img
                                className="item-img"
                                //src="../images/card3.png"
                                src={
                                  item.banner_pic
                                    ? item.banner_pic
                                    : "../images/card3.png"
                                }
                                alt="seacrh"
                              />
                              <div className="txt">
                                <Link
                                  to={"../UserProfile?account=" + item.account}
                                >
                                  {" "}
                                  <h5>
                                    {item.user_name}{" "}
                                    <img
                                      className="mark"
                                      src="../images/verify.png"
                                      alt="seacrh"
                                    />
                                  </h5>{" "}
                                </Link>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </Scrollbars>
                    </div>
                  }
                </div>
                <ul className="navigation">
                  <li key="0">
                    <Link to="/ExploreCollections" className="active">
                      Explore
                    </Link>
                  </li>
                  <li key="1">
                    <Link
                      style={{ display: this.state.accountId ? "block" : "none" }}
                      to="/CreateItem"
                    >
                      Create
                    </Link>
                    <Link
                      style={{ display: this.state.accountId ? "none" : "block" }}
                      to="/Login"
                    >
                      Create
                    </Link>
                  </li>
                  <li key="2">
                    <Link to="/">About</Link>
                  </li>
                </ul> 
            </div>
             
              <div className="navbar__right"> 
              <button className="button">Connect Wallet</button>
              <button className="btn-shop" onClick={() => this.cartPopup()}> <img  src="../images/bag.svg" alt="Search" /><span>{this.state.cartList.length}</span></button>
                <div className="media-img dropdown headerProfileImg">
                  {this.state.accountId == null ? (
                    <Link to="/Login">
                      <img
                        src="../images/icons8-male-user-100.png"
                        alt="card1"
                      />
                    </Link>
                  ) : (
                    <img
                      src={
                        this.state.accountId != null
                          ? this.state.profilePicture
                            ? this.state.profilePicture
                            : "../images/icons8-male-user-100.png"
                          : "../images/icons8-male-user-100.png"
                      }
                      alt="card2"
                    />
                  )}

                  {this.state.accountId != null ? (
                    <div className="dropdown-content" style={{ marginLeft: -124+'px'}}>
                      <Link to="../UserProfile">Profile</Link>
                      <Link to="../MyCollections">My Collections</Link>
                      <a //to="/Login"
                        onClick={() => this.logoutUser()}
                      >
                        Log Out
                      </a>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="button-wrap">
                  <button
                    className="search"
                    onClick={() => this.searchBoxFun()}
                  >
                    <img src="../images/search-white.png" alt="Search" />
                  </button>
                  <button
                    className="hamburger"
                    onClick={() => this.mobileMenuFun()}
                  >
                    <i className="material-icons-outlined">menu</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="mobile-search-box">
            <button
              type="button"
              onClick={(event) => this.mobileSearchBack(event)}
            >
              <i
                className="material-icons"
                onClick={(event) => this.mobileSearchBack(event)}
              >
                chevron_left
              </i>
            </button>
            {/* <input
              type="text"
              aria-invalid="false"
              aria-multiline="false"
              placeholder="Search OpenSea"
              onKeyUp={(event) => {
                this.getSearchBar({
                  target: {
                    value: event.target.value,
                  },
                });
              }}
            /> */}
            <input
              type="text"
              placeholder="Search"
              value={this.state.value}
              onChange={(e) => this.getSearchBar(e)}
              onKeyUp={(event) => this.searchResultPage(event)}
            />
            <button
              type="button"
              onClick={(event) => this.searchResultPageIcon(event)}
            >
              <img src="../images/search-mobile.png" alt="Search"
                style={{ width: 20 + "px", height: 20 + "px" }} />
            </button>
            {
              <div
                className="search-autocomplete"
                style={{
                  display:
                    (this.state.users.length > 0 ||
                      this.state.assets.length > 0 ||
                      this.state.collections.length > 0) &&
                      this.isOpen
                      ? "block"
                      : "none",
                }}
              >
                <Scrollbars className="custmScrollbar">
                  <ul className="search-autocomplete_list">
                    <label>Items</label>
                    {this.state.assets.map((item) => (
                      <li key="0">
                        <img
                          className="item-img"
                          src="../images/card1.png"
                          alt="seacrh"
                        />
                        <div className="txt">
                          <Link to={"../NftDetails/?assetId=" + item.asset_id}>
                            <h5>
                              {item.asset_name}{" "}
                              <img
                                className="mark"
                                src="../images/verify.png"
                                alt="seacrh"
                              />
                            </h5>{" "}
                            {/* <span>1 of 100</span> */}
                          </Link>
                        </div>
                      </li>
                    ))}
                  </ul>

                  <ul className="search-autocomplete_list">
                    <label>Collections</label>
                    {this.state.collections.map((item, index) => (
                      <li key={index}>
                        <img
                          className="item-img"
                          src="../images/card2.png"
                          alt="seacrh"
                        />
                        <div className="txt">
                          <Link
                            to={
                              "../CollectionDetails/?collectionId=" +
                              item.collection_id
                            }
                          >
                            <h5>
                              {item.collection_name}{" "}
                              <img
                                className="mark"
                                src="../images/verify.png"
                                alt="seacrh"
                              />
                            </h5>{" "}
                          </Link>
                        </div>
                      </li>
                    ))}
                  </ul>

                  <ul className="search-autocomplete_list">
                    <label>Users</label>
                    {this.state.users.map((item, index) => (
                      <li key={index}>
                        <img
                          className="item-img"
                          src="../images/card3.png"
                          alt="seacrh"
                        />
                        <div className="txt">
                          <Link to={"../UserProfile?account=" + item.account}>
                            {" "}
                            <h5>
                              {item.user_name}{" "}
                              <img
                                className="mark"
                                src="../images/verify.png"
                                alt="seacrh"
                              />
                            </h5>{" "}
                          </Link>
                        </div>
                      </li>
                    ))}
                  </ul>
                </Scrollbars>
              </div>
            }
          </div>
        </header>
        <div className="cart-popup" >
          <div className="cart-popup__aside">
            <Scrollbars className="custmScrollbar">
              <button className="btn-close" onClick={() => this.explorrerCollectionClose()}> <i className="material-icons-outlined">close</i></button>
              <div className="cart-popup__top">
                <div className="cart-popup__ttl">
                  <h2>CART</h2>
                  <div className="count">{this.state.cartList.length}</div>
                  <a href="javascript:void(0)" style={{ display: this.state.cartList.length == 0 ? 'none' : 'block' }} onClick={() => this.removeCart('All',1)} className="btn-clear">Clear All</a>
                </div>
                <ul className="cart-list">
                  {this.state.cartList.map((item, index) => (
                    <li>
                      <a href="javascript:void(0)" >
                        <div className="img"><img src={item.img_loc_thumbnail} /> <button onClick={() => this.removeCart(item.cart_id,1)} className="btn-del"><i className="material-icons">cancel</i></button> </div>
                        <div className="data">
                          <h3>{item.domain_name} <label>{item.price} {item.currency_name}</label> </h3>
                          <h5>{item.desc}
                            {/* <img className="mark" src="../images/verify.png"  /> */}
                          </h5>
                          <span>Creator Fees: 7.5%</span>
                        </div>
                      </a>
                    </li>
                  ))}

                  {/* <li>
                    <a href="#">
                      <div className="img"><img src="../images/nft-details.jpg"/> <button className="btn-del"><i className="material-icons">cancel</i></button> </div>
                      <div className="data">
                        <h3>#3368 <label>1.153 ETH</label></h3>
                        <h5>Bored Ape Yacht Club <img className="mark" src="../images/verify.png"  /></h5>
                        <span>Creator Fees: 7.5%</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <div className="img"><img src="../images/nft-details.jpg"/> <button className="btn-del"><i className="material-icons">cancel</i></button> </div>
                      <div className="data">
                        <h3>#336 <label>1.153 ETH</label></h3>
                        <h5>Bored Ape Yacht Club <img className="mark" src="../images/verify.png"  /></h5>
                        <span>Creator Fees: 7.5%</span>
                      </div>
                    </a>
                  </li> */}
                </ul>
                <div className="diff-wallet">
                  <h6>Send to a different wallet <button><i className="material-icons">keyboard_arrow_up</i></button></h6>
                  <div className="form-group" >
                    <input type="text" className="form-control" placeholder="Enter wallet address (0x1ed3... or destination.eth)" />
                  </div>
                </div>
              </div>
              <div className="cart-popup__btm">
                <h2>Total <div className="price"><label>{this.state.totalPrice} ETH</label> <span>(${this.state.totalUsd})</span></div></h2>
                <button disabled={this.state.cartList.length == 0 ? true : false} onClick={() => this.openCheckoutPopup()} className="button">Checkout</button>
              </div>
            </Scrollbars>
          </div>
        </div>
      </>
    );
  };
}

//export default Header;
